import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class RelateMultipleProductsArgs extends ActionArgs {
  @Field(() => String)
  from: string

  @Field(() => [String])
  to?: string[]
}
